import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Cotacoes.css';

function Cotacoes() {
    const { usuario } = useAuth();
    const [dados, setDados] = useState(null);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);
    const [aberto, setAberto] = useState({ 0: true }); // Abre a primeira categoria por padrão

    const toggleAccordion = (index) => {
        setAberto(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const getSiglaEstado = (estado) => {
        if (!estado) return null;
        const est = estado.trim().toUpperCase();
        if (est.length === 2) return est;
        
        const mapa = {
            'MINAS GERAIS': 'MG', 'SÃO PAULO': 'SP', 'SAO PAULO': 'SP',
            'GOIÁS': 'GO', 'GOIAS': 'GO', 'MATO GROSSO': 'MT',
            'MATO GROSSO DO SUL': 'MS', 'PARANÁ': 'PR', 'PARANA': 'PR',
            'RIO GRANDE DO SUL': 'RS', 'RONDÔNIA': 'RO', 'RONDONIA': 'RO',
            'TOCANTINS': 'TO', 'PARÁ': 'PA', 'PARA': 'PA',
            'BAHIA': 'BA', 'MARANHÃO': 'MA', 'MARANHAO': 'MA',
            'ACRE': 'AC', 'SANTA CATARINA': 'SC', 'CEARÁ': 'CE', 'CEARA': 'CE',
            'ALAGOAS': 'AL', 'PERNAMBUCO': 'PE', 'RIO GRANDE DO NORTE': 'RN',
            'PARAIBA': 'PB', 'PARAÍBA': 'PB', 'SERGIPE': 'SE',
            'ESPÍRITO SANTO': 'ES', 'ESPIRITO SANTO': 'ES', 'RIO DE JANEIRO': 'RJ',
            'PIAUÍ': 'PI', 'PIAUI': 'PI', 'AMAZONAS': 'AM', 'RORAIMA': 'RR',
            'AMAPÁ': 'AP', 'AMAPA': 'AP', 'DISTRITO FEDERAL': 'DF'
        };
        return mapa[est] || est;
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        
        const carregarCotacoes = async () => {
            try {
                const response = await fetch('http://localhost:3001/api/cotacoes');
                const data = await response.json();
                if (data.error) throw new Error(data.message);
                setDados(data);
            } catch (e) {
                setErro(e.message || 'Não foi possível carregar as cotações');
            } finally {
                setLoading(false);
            }
        };

        carregarCotacoes();
    }, []);

    if (loading) {
        return (
            <div className="cotacoes-page">
                <div className="cotacoes-container" style={{ textAlign: 'center', paddingTop: '100px' }}>
                    <h2 style={{ color: '#22c55e' }}>Carregando cotações de mercado...</h2>
                </div>
            </div>
        );
    }

    if (erro || !dados) {
        return (
            <div className="cotacoes-page">
                <div className="cotacoes-container" style={{ textAlign: 'center', paddingTop: '100px' }}>
                    <h2 style={{ color: '#ef4444' }}>{erro || 'Erro ao carregar dados'}</h2>
                </div>
            </div>
        );
    }

    const getIconStatus = (status) => {
        switch (status) {
            case 'alta': return '▲';
            case 'baixa': return '▼';
            default: return '■';
        }
    };

    const getCorVariacao = (status) => {
        switch (status) {
            case 'alta': return 'variacao-alta';
            case 'baixa': return 'variacao-baixa';
            default: return 'variacao-estavel';
        }
    };

    const siglaUser = getSiglaEstado(usuario?.estado);
    const cotacoesDoEstado = [];

    if (siglaUser && dados?.tabelas) {
        dados.tabelas.forEach(tabela => {
            const linhasFiltradas = tabela.linhas.filter(linha => 
                linha.praca.toUpperCase().includes(siglaUser)
            );
            if (linhasFiltradas.length > 0) {
                cotacoesDoEstado.push({
                    categoria: tabela.categoria,
                    colunas: tabela.colunas,
                    linhas: linhasFiltradas
                });
            }
        });
    }

    return (
        <div className="cotacoes-page">
            <div className="cotacoes-container">
                
                <div className="cotacoes-header">
                    <h1>Cotações Agroov</h1>
                    <p>Preços médios diários das principais commodities e praças do agronegócio brasileiro</p>
                    <span className="data-atualizacao">
                        📅 Atualizado em: {dados.atualizadoEm}
                    </span>
                </div>





                {/* Tabelas por Categoria */}
                <div className="tabelas-container">
                    {dados.tabelas?.map((tabela, index) => (
                        <div className="tabela-bloco" key={index} style={{ paddingBottom: aberto[index] ? '30px' : '15px' }}>
                            <h2 
                                onClick={() => toggleAccordion(index)} 
                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: aberto[index] ? '20px' : '0' }}
                            >
                                {tabela.categoria}
                                <span style={{ fontSize: '1rem', color: '#22c55e' }}>
                                    {aberto[index] ? '▲ Recolher' : '▼ Expandir'}
                                </span>
                            </h2>

                            {aberto[index] && (
                                <table className="cotacoes-table">
                                    <thead>
                                        <tr>
                                            {tabela.colunas.map((col, i) => (
                                                <th key={i}>{col}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tabela.linhas.map((linha, i) => (
                                            <tr key={i}>
                                                <td>{linha.praca}</td>
                                                <td>{linha.aVista}</td>
                                                <td>{linha.trintaDias}</td>
                                                <td>
                                                    <span className={linha.variacao.startsWith('+') ? 'variacao-alta' : linha.variacao.startsWith('-') ? 'variacao-baixa' : 'variacao-estavel'}>
                                                        {linha.variacao}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    ))}
                </div>

                <p className="fonte-aviso">
                    * As cotações apresentadas são médias indicativas de mercado e servem apenas como referência para negociação.
                </p>

            </div>
        </div>
    );
}

export default Cotacoes;
